import { FC, useState } from "react";
import { Fab, Grid } from "@mui/material";
import { Box, styled } from "@mui/system";
import { H3 } from "../../../components/Typography";
import muiIcons from "../../../components/icons/mui-icons";
import { CardContainer } from "../../../components/CardContainer";
import Breadcrumb from "../../../components/breadcrumb/Breadcrumb";
import ButtonLoader from "../../../components/buttons/ButtonLoader";
import { GullButton } from "../../../components/buttons/GullButton";

const Title = styled(H3)(() => ({
  marginBottom: "1.5rem",
}));

const AppButtons: FC = () => {
  const {
    FacebookIcon,
    GoogleIcon,
    InstagramIcon,
    TwitterIcon,
    LinkedinIcon,
    YoutubeIcon,
  } = muiIcons;

  const [loadButton, setLoadButton] = useState(true);

  return (
    <>
      <Breadcrumb name="ui-kits" subName="Buttons" path="/dashboard/v1" />
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Rounded Contained Buttons</Title>
            <GullButton rounded={true} variant="contained" color="primary">
              Primary
            </GullButton>
            <GullButton rounded={true} variant="contained" color="secondary">
              Secondary
            </GullButton>
            <GullButton rounded={true} variant="contained" color="success">
              Success
            </GullButton>
            <GullButton rounded={true} variant="contained" color="error">
              Error
            </GullButton>
            <GullButton rounded={true} variant="contained" color="info">
              Info
            </GullButton>
            <GullButton rounded={true} variant="contained" color="warning">
              Warning
            </GullButton>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Rounded Outline Buttons</Title>
            <GullButton rounded={true} variant="outlined" color="primary">
              Primary
            </GullButton>
            <GullButton rounded={true} variant="outlined" color="secondary">
              Secondary
            </GullButton>
            <GullButton rounded={true} variant="outlined" color="success">
              Success
            </GullButton>
            <GullButton rounded={true} variant="outlined" color="error">
              Error
            </GullButton>
            <GullButton rounded={true} variant="outlined" color="info">
              Info
            </GullButton>
            <GullButton rounded={true} variant="outlined" color="warning">
              Warning
            </GullButton>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Rectangle Buttons</Title>
            <GullButton variant="contained" color="primary">
              Primary
            </GullButton>
            <GullButton variant="contained" color="secondary">
              Secondary
            </GullButton>
            <GullButton variant="contained" color="success">
              Success
            </GullButton>
            <GullButton variant="contained" color="error">
              Error
            </GullButton>
            <GullButton variant="contained" color="info">
              Info
            </GullButton>
            <GullButton variant="contained" color="warning">
              Warning
            </GullButton>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Rectangle Outline Buttons</Title>
            <GullButton variant="outlined" color="primary">
              Primary
            </GullButton>
            <GullButton variant="outlined" color="secondary">
              Secondary
            </GullButton>
            <GullButton variant="outlined" color="success">
              Success
            </GullButton>
            <GullButton variant="outlined" color="error">
              Error
            </GullButton>
            <GullButton variant="outlined" color="info">
              Info
            </GullButton>
            <GullButton variant="outlined" color="warning">
              Warning
            </GullButton>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Different Size Buttons</Title>
            <GullButton
              variant="contained"
              color="primary"
              sx={{ width: "100%" }}
            >
              Primary
            </GullButton>
            <GullButton
              variant="contained"
              color="secondary"
              sx={{ width: "100%" }}
            >
              Secondary
            </GullButton>
            <GullButton
              variant="contained"
              color="success"
              sx={{ width: "100%" }}
            >
              Success
            </GullButton>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Different Size Buttons</Title>
            <Box>
              <GullButton
                fontSize="12px"
                variant="contained"
                color="primary"
                sx={{ padding: ".3rem .8rem" }}
              >
                Primary
              </GullButton>
              <GullButton
                fontSize="12px"
                variant="contained"
                color="secondary"
                sx={{ padding: ".3rem .8rem" }}
              >
                Secondary
              </GullButton>
              <GullButton
                fontSize="12px"
                variant="contained"
                color="success"
                sx={{ padding: ".3rem .8rem" }}
              >
                Success
              </GullButton>
            </Box>

            <Box>
              <GullButton
                fontSize="16px"
                variant="contained"
                color="primary"
                sx={{ padding: ".3rem 1.2rem" }}
              >
                Primary
              </GullButton>
              <GullButton
                fontSize="16px"
                variant="contained"
                color="secondary"
                sx={{ padding: ".3rem 1.2rem" }}
              >
                Secondary
              </GullButton>
              <GullButton
                fontSize="16px"
                variant="contained"
                color="success"
                sx={{ padding: ".3rem 1.2rem" }}
              >
                Success
              </GullButton>
            </Box>

            <Box>
              <GullButton
                fontSize="20px"
                variant="contained"
                color="primary"
                sx={{ padding: ".3rem 1.6rem" }}
              >
                Primary
              </GullButton>
              <GullButton
                fontSize="20px"
                variant="contained"
                color="secondary"
                sx={{ padding: ".3rem 1.6rem" }}
              >
                Secondary
              </GullButton>
              <GullButton
                fontSize="20px"
                variant="contained"
                color="success"
                sx={{ padding: ".3rem 1.6rem" }}
              >
                Success
              </GullButton>
            </Box>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Icons Buttons</Title>
            <Box>
              <GullButton variant="contained" color="primary">
                <FacebookIcon sx={{ mr: "5px", fontSize: 14 }} />
                Facebook
              </GullButton>
              <GullButton variant="contained" color="secondary">
                <GoogleIcon sx={{ mr: "5px" }} />
                Google
              </GullButton>
              <GullButton variant="contained" color="success">
                <TwitterIcon sx={{ mr: "5px" }} />
                Twitter
              </GullButton>
              <GullButton variant="contained" color="error">
                <InstagramIcon sx={{ mr: "5px" }} />
                Instagram
              </GullButton>
              <GullButton variant="contained" color="info">
                <LinkedinIcon sx={{ mr: "5px", fontSize: 14 }} />
                Linkedin
              </GullButton>
              <GullButton variant="contained" color="warning">
                <YoutubeIcon sx={{ mr: "5px" }} />
                Youtube
              </GullButton>
            </Box>

            <Box mt="20px">
              <Fab sx={{ m: "5px" }} size="medium" color="primary">
                <FacebookIcon />
              </Fab>
              <Fab sx={{ m: "5px" }} size="medium" color="secondary">
                <GoogleIcon />
              </Fab>
              <Fab sx={{ m: "5px" }} size="medium" color="primary">
                <TwitterIcon />
              </Fab>
              <Fab sx={{ m: "5px" }} size="medium" color="secondary">
                <InstagramIcon />
              </Fab>
              <Fab sx={{ m: "5px" }} size="medium" color="primary">
                <LinkedinIcon />
              </Fab>
              <Fab sx={{ m: "5px" }} size="medium" color="secondary">
                <YoutubeIcon />
              </Fab>
            </Box>
          </CardContainer>
        </Grid>

        <Grid item xs={12} md={6}>
          <CardContainer>
            <Title>Loading Buttons</Title>
            <Box>
              <GullButton
                color="primary"
                fontSize="12px"
                variant="contained"
                sx={{ padding: ".3rem .8rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader size={14} loadButton={loadButton} />
                Primary
              </GullButton>
              <GullButton
                fontSize="12px"
                variant="contained"
                color="secondary"
                sx={{ padding: ".3rem .8rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader size={14} loadButton={loadButton} />
                Secondary
              </GullButton>
              <GullButton
                fontSize="12px"
                variant="contained"
                color="success"
                sx={{ padding: ".3rem .8rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader size={14} loadButton={loadButton} />
                Success
              </GullButton>
            </Box>

            <Box>
              <GullButton
                fontSize="16px"
                variant="contained"
                color="primary"
                sx={{ padding: ".3rem 1.2rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader loadButton={loadButton} />
                Primary
              </GullButton>
              <GullButton
                fontSize="16px"
                variant="contained"
                color="secondary"
                sx={{ padding: ".3rem 1.2rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader loadButton={loadButton} />
                Secondary
              </GullButton>
              <GullButton
                fontSize="16px"
                variant="contained"
                color="success"
                sx={{ padding: ".3rem 1.2rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader loadButton={loadButton} />
                Success
              </GullButton>
            </Box>

            <Box>
              <GullButton
                fontSize="20px"
                variant="contained"
                color="primary"
                sx={{ padding: ".3rem 1.6rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader size={24} loadButton={loadButton} />
                Primary
              </GullButton>
              <GullButton
                fontSize="20px"
                variant="contained"
                color="secondary"
                sx={{ padding: ".3rem 1.6rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader size={24} loadButton={loadButton} />
                Secondary
              </GullButton>
              <GullButton
                fontSize="20px"
                variant="contained"
                color="success"
                sx={{ padding: ".3rem 1.6rem" }}
                onClick={() =>
                  loadButton ? setLoadButton(false) : setLoadButton(true)
                }
              >
                <ButtonLoader size={24} loadButton={loadButton} />
                Success
              </GullButton>
            </Box>
          </CardContainer>
        </Grid>
      </Grid>
    </>
  );
};

export default AppButtons;
